import axios from "axios";
import AuthService from "../services/AuthService";
import { checkToken, sessionCookies } from "../utils/helpers";

const saveToken = token => {
  sessionCookies.set("token", token);
  localStorage.setItem("token", token);
};
const local = checkToken() && JSON.parse(localStorage.getItem("user"));

let localAdmin = false;
let localSrc = false;

if (local && local.user) {
  localAdmin = local.user.admin;
  localSrc = local.user.src;
}

const getDefaultState = () => ({
  status: "",
  token: checkToken() && localStorage.getItem("token") || "",
  requiresAuth: false,
  requiresAdmin: false,
  coordinatorBool: false,
  coordinator: JSON.parse(localStorage.getItem("coordinator")) || {
    uuid: "",
    active: false,
    first_name: "",
    middle_name: "",
    last_name: "",
    designation: "",
    sex: "",
    dob: null,
    mobile_1: "",
    mobile_2: "",
    email: "",
    country: "",
    region: "",
    district: "",
    village: "",
    address: "",
    course_name: "",
    date_comp: "",
    institution: "",
  },
  trainer: {
    uuid: "",
    active: false,
    first_name: "",
    middle_name: "",
    last_name: "",
    designation: "",
    sex: "",
    dob: null,
    mobile_1: "",
    mobile_2: "",
    email: "",
    country: "",
    region: "",
    district: "",
    village: "",
    address: "",
    course_name: "",
    date_comp: "",
    institution: "",
  },
  user: checkToken() && JSON.parse(localStorage.getItem("userLogin")) || {
    id: "",
    email: "",
    user_name: "",
    admin: localAdmin,
    uuid: "",
    src: localSrc,
    user_type:""
  },
});

const trainer = () => {
  let tempTrainer;
  try {
    tempTrainer = JSON.parse(localStorage.getItem("trainer"));
  } catch (e) {
    return {
      uuid: "",
      active: false,
      first_name: "",
      middle_name: "",
      last_name: "",
      designation: "",
      sex: "",
      dob: null,
      mobile_1: "",
      mobile_2: "",
      email: "",
      country: "",
      region: "",
      district: "",
      village: "",
      address: "",
      course_name: "",
      date_comp: "",
      institution: "",
    };
  }
  return tempTrainer;
};

const coordinator = () => {
  let tempCoordinator;
  try {
    tempCoordinator = JSON.parse(localStorage.getItem("coordinator"));
  } catch (e) {
    return {
      uuid: "",
      active: false,
      first_name: "",
      middle_name: "",
      last_name: "",
      designation: "",
      sex: "",
      dob: null,
      mobile_1: "",
      mobile_2: "",
      email: "",
      country: "",
      region: "",
      district: "",
      village: "",
      address: "",
      course_name: "",
      date_comp: "",
      institution: "",
    };
  }
  return tempCoordinator;
};

const auth = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, payload) {
      state.status = "success";
      state.token = payload.token;
      state.user = payload.user;
      state.coordinator = payload.coordinator;
      state.trainer = payload.trainer;
      state.coordinatorBool = payload.coordinatorBool;
    },
    auth_error(state) {
      state.status = "error";
    },
    logout(state) {
      state.status = "";
      state.token = "";
      state.user = {
        id: "",
        email: "",
        user_name: "",
        admin: false,
        uuid: "",
      };
    },
    requiresAuth(state) {
      state.requiresAuth = !state.requiresAuth;
    },
    requiresAdmin(state) {
      state.requiresAdmin = !state.requiresAdmin;
    },
  },
  actions: {
    REQUIRES_AUTH({ commit }) {
      commit("requiresAuth");
    },
    REQUIRES_ADMIN({ commit }) {
      commit("requiresAdmin");
    },
    LOGIN({ commit }, userDetails) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        AuthService.loginUser(userDetails)
          .then((resp) => {
            const { token, user } = resp.data;

            saveToken(token);
            axios.defaults.headers.common.Authorization = token;

            AuthService.checkUserType(user.uuid)
              .then(res => {
                //console.log("user type check res: ", res);
                const {
                  coordinator
                } = res.data;
                const {
                  trainer
                } = res.data;
                const {
                  coordinatorBool
                } = res.data;

                var coodBool = res.data;
                if(coodBool.coordinatorBool){
                  localStorage.setItem(
                    "coordinator",
                    JSON.stringify(coodBool.coordinator)
                  );
                }else{
                  localStorage.setItem(
                    "coordinator",
                    JSON.stringify(null)
                  );
                }

                if (trainer == undefined || trainer == null) {
                  localStorage.setItem("trainer", JSON.stringify(trainer));
                }

                if(user.user_type == 'src'){
                  localStorage.setItem("src",true)
                }

                //console.log(user);
                const userLog = {
                  id: user.id,
                  email: user.email,
                  user_name: user.user_name,
                  admin: (user.user_type == 'src') ? false : user.admin,
                  uuid: user.uuid,
                  src: (user.user_type == 'src') ? true : false,
                  user_type: user.user_type
                }

                localStorage.setItem("userLogin", JSON.stringify(userLog));

                const payload = {
                  token,
                  user,
                  coordinatorBool,
                  coordinator,
                  trainer,
                };
                commit("auth_success", payload);
                resolve(resp);
                location.reload()
                //console.log("this.state: ", this.state);
              })
              .catch((err) => {
                console.log(err);
              });
          })
          .catch((err) => {
            commit("auth_error");
            sessionCookies.remove("token");
            localStorage.removeItem("token");
            localStorage.removeItem("userLogin");
            localStorage.removeItem("coordinator");
            localStorage.removeItem("trainer");
            localStorage.removeItem("src");
            localStorage.removeItem("user");
            reject(err);
          });
      });
    },
    REGISTER({ commit }, userDetails) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          url: "http://localhost:3000/register",
          data: userDetails,
          method: "POST",
        })
          .then((resp) => {
            const { token, user } = resp.data;
            saveToken(token);
            axios.defaults.headers.common.Authorization = token;
            commit("auth_success", token, user);
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error", err);
            sessionCookies.remove("token");
            localStorage.removeItem("token");
            localStorage.removeItem("userLogin");
            localStorage.removeItem("coordinator");
            localStorage.removeItem("trainer");
            localStorage.removeItem("src");
            localStorage.removeItem("user");
            reject(err);
          });
      });
    },
    LOGOUT({ commit }) {
      return new Promise((resolve, reject) => {
        commit("logout");
        sessionCookies.remove("token");
        localStorage.removeItem("token");
        localStorage.removeItem("userLogin");
        localStorage.removeItem("coordinator");
        localStorage.removeItem("trainer");
        localStorage.removeItem("src");
        localStorage.removeItem("user");
        delete axios.defaults.headers.common.Authorization;
        resolve();
      });
    },
  },
  getters: {
    isLoggedIn: (state) => !!state.token,
    authStatus: (state) => state.status,
    isAdmin: (state) => state.user.admin,
    isSRC: (state) => state.user.src,
    getTrainerUuid: (state) => {
      if (state.trainer != null) return state.trainer.uuid;
      else return null;
    },
    getCoordinatorUuid: (state) => {
      if (state.coordinator != null) {
        return state.coordinator.uuid;
      }
      else return null;
    },
    requiresAdmin: (state) => state.requiresAdmin,
    requiresAuth: (state) => state.requiresAuth,
  },
};

export default auth;
